import { createServerOnlyFn } from "@tanstack/react-start";
import {
    createMcpConnectionRouteHandler,
    bindKitsLinkAuthorization,
    createMcpConnectionService,
    notifyKitsOfMcpConnection,
} from "@/features/mcp-connections/index.server";
import { resolveExistingViewerRef } from "@/lib/core/auth";
import { getMcpCredentialManagementClient } from "@/lib/core/mcp-credentials/mcp-credential-management-client-from-env";
import { getTelemetry } from "@/lib/core/telemetry.server";

const handleMcpConnectionRequest = createServerOnlyFn(
    async ({ request }: { request: Request }) => {
        const handle = createMcpConnectionRouteHandler({
            async resolveOwnerUserId() {
                const viewer = await resolveExistingViewerRef();
                return viewer?.isAuthenticated === true
                    ? viewer.viewerId
                    : null;
            },
            connectionService: () => {
                const client = getMcpCredentialManagementClient();
                return client ? createMcpConnectionService(client) : null;
            },
            async recordEvent(event) {
                const telemetry = await getTelemetry();
                telemetry.log.info(event.name, event.attributes);
                await telemetry.flush();
            },
            bindLinkAuthorization: bindKitsLinkAuthorization,
            async notifyConnected(connected) {
                await notifyKitsOfMcpConnection(connected);
            },
        });
        return await handle(request);
    },
);

export const mcpConnectionsRoute = {
    server: {
        handlers: {
            POST: ({ request }: { request: Request }) =>
                handleMcpConnectionRequest({ request }),
        },
    },
};
